<template>
  <div
    class="rounded-full overflow-hidden flex-shrink-0 bg-hint"
    :style="style">
    <Attachment v-if="logoId" :id="logoId" />
  </div>
</template>

<script type="text/javascript">
import Attachment from '@/components/global/Attachment.vue';

export default {
  name: 'PartnerLogo',
  components: { Attachment },
  props: {
    partner: {
      type: Object,
      required: true,
    },
    size: {
      type: Number,
      required: false,
      default: 48,
    },
  },
  computed: {
    logoId() {
      return this.partner?.logo?.id;
    },
    style() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
      };
    },
  },
};
</script>
